import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
   
    card:{
    margin:10,
 

        '&:hover': {
            backgroundColor:theme.palette.secondary.main,
            transition: "background-color 1s linear",
            color:"white"
            
          
        }
    },
    cardContent:{
        
        display: "flex", alignItems: "center"
    }
}));
